import {
  Button,
  Card,
  CardContent,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";

import { FieldArray } from "formik";
import useLocale from "../../../../hooks/useLocale";

import { sortOrderDocs } from "../../../../utils/sortOrderDocuments";
import DocumentList from "./DocumentList";

const UploadDocuments = ({ docsPerKind, values }) => {
  const { t } = useLocale();

  const [uploadedDocumentsIds, setUploadedDocumentsIds] = useState([]);
  // const [imageFormatError, setImageFormatError] = useState(false);
  const [imageFormatErrorText, setImageFormatErrorText] = useState("");

  useEffect(() => {
    setUploadedDocumentsIds(values.documents?.map((doc) => doc?.id));
  }, [values.documents]);

  const docsPerKindSorted = sortOrderDocs(docsPerKind);

  return (
    <>
      <Card raised={true}>
        <CardContent>
          <FieldArray
            name="documents"
            render={(arrayHelpers) => (
              <DocumentList
                docsPerKindSorted={docsPerKindSorted}
                uploadedDocumentsIds={uploadedDocumentsIds}
                imageFormatErrorText={imageFormatErrorText}
                setImageFormatErrorText={setImageFormatErrorText}
                arrayHelpers={arrayHelpers}
              />
            )}
          />
        </CardContent>
      </Card>
    </>
  );
};

export default UploadDocuments;
